import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentGql } from './DatasourcesDisplayGridRowDataFragmentGql';

export const FlowUpstreamDatasourcesQueryGql: DocumentNode = gql`
query FlowUpstreamDatasourcesQuery($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragment
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentGql}
`;
